import timeline from './examples/default';

const {
  bars,
  layout,
  milestones,
  highlightWeekends,
  shouldCompact,
  firstDate,
  totalDays,
  screaming,
  scaleMode,
} = timeline;

export {
  bars,
  layout,
  milestones,
  highlightWeekends,
  shouldCompact,
  firstDate,
  totalDays,
  screaming,
  scaleMode,
};
